const BASEURL = process.env.REACT_APP_API_URL || "http://localhost:8000/graphql/";
export const MEDIAURL = process.env.REACT_APP_MEDIA_URL || "http://localhost:8000/";

export default BASEURL;
